import React from 'react';
import cn from 'classnames';

import {ISocialsProps} from './ISocials';

import styles from './Socials.module.scss';

const Socials = ({as, classNames, children}: ISocialsProps) => {
	if (!children) {
		return null;
	}

	const TagName = as || 'div';

	return <TagName className={cn(styles['socials'], classNames)}>{children}</TagName>;
};

export default Socials;
